import cities from './modules/cities';
import directions from './modules/directions';
import departments from './modules/departments';
import vacancies from './modules/vacancies';
import internships from './modules/internships';
import leadership from './modules/leadership';
import dummies from './modules/dummies';
import statuses from './modules/statuses';

export default {
  namespaced: true,
  modules: {
    cities,
    directions,
    departments,
    vacancies,
    internships,
    leadership,
    dummies,
    statuses
  }
};
